import type { App } from 'vue'

export default function (app: App) {
  // Configure Monaco Environment
  window.MonacoEnvironment = {
    getWorkerUrl: function (workerId, label) {
      if (label === 'json') {
        return '/node_modules/monaco-editor/esm/vs/language/json/json.worker.js'
      }
      if (label === 'css' || label === 'scss' || label === 'less') {
        return '/node_modules/monaco-editor/esm/vs/language/css/css.worker.js'
      }
      if (label === 'html' || label === 'handlebars' || label === 'razor') {
        return '/node_modules/monaco-editor/esm/vs/language/html/html.worker.js'
      }
      if (label === 'typescript' || label === 'javascript') {
        return '/node_modules/monaco-editor/esm/vs/language/typescript/ts.worker.js'
      }
      return '/node_modules/monaco-editor/esm/vs/editor/editor.worker.js'
    },
  }
}
